var base = require('settings/teams/send-invitation');

Vue.component('spark-send-invitation', {
  mixins: [base],
  props: ['isActive'],
  methods: {
    closeModal() {
      this.$emit('close');
      this.cleanFields();
    },
    cleanFields() {
      setTimeout(() => {
        this.form.email = '';
        this.form.resetStatus();
      }, 15);
    }
  },
  watch: {
    'form.successful'() {
      if (this.form.successful) {
        (new Notyf()).confirm("Invitation successfully sent.");
        this.closeModal();
      }
    },
    'form.errors'() {
      if (this.form.errors) {
        (new Notyf()).alert("Error sending invitation.");
      }
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/teams/send-invitation.js